import { useState } from 'react';
import { FeatureAnnouncementModalPageMedia } from 'src/components/Modals/FeatureAnnouncementModal/types';
import StepIndicator from 'src/components/primitives/StepIndicator/StepIndicator';
import { cj } from 'src/utils/classNames';

interface Props {
	title: string;
	description: React.ReactNode;
	media: FeatureAnnouncementModalPageMedia;
	/**
	 * Gives the container a fixed height while the media is loading to reduce layout shift.
	 */
	mediaLoadingHeight: number | string;
	step: number;
	totalSteps: number;
}

export default function FeatureAnnouncementBaseLayout({
	title,
	description,
	media,
	mediaLoadingHeight,
	step,
	totalSteps,
}: Props) {
	const [isMediaLoaded, setIsMediaLoaded] = useState(false);

	return (
		<>
			{/** Media */}
			<div
				className={cj(
					'relative h-auto w-full',
					'overflow-hidden rounded-sm border border-stroke-divider'
				)}
				style={{ height: !isMediaLoaded ? mediaLoadingHeight : undefined }}
			>
				{!isMediaLoaded && media.type === 'image' && (
					<div className="absolute inset-0 animate-pulse rounded-sm bg-input-border" />
				)}

				{media.type === 'image' ? (
					<img
						src={media.src}
						alt={title}
						className="h-full w-full object-cover"
						onLoad={() => setIsMediaLoaded(true)}
					/>
				) : (
					<video
						src={media.src}
						poster={media.previewImgSrc}
						autoPlay
						loop
						muted
						playsInline
						controls={false}
						style={{ width: '100%', height: '100%', display: 'block' }}
						onLoadedData={() => setIsMediaLoaded(true)}
					/>
				)}
			</div>

			<div className="flex justify-center">
				<StepIndicator currentStep={step} totalSteps={totalSteps} />
			</div>

			<span className="typo-label-md text-text-default sm:typo-heading-h4">
				{title}
			</span>
			<span className="typo-body-sm text-text-secondary">{description}</span>
		</>
	);
}
